import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addPeople: {
		id: 'calendar.add-people-button.add-people',
		defaultMessage: 'Add people',
		description: 'Button text to add people to the calendar',
	},
});
